/*
 * Copyright © Manatee. 2026 All Rights Reserved.
 * Proprietary and confidential.
 */

import { lazyPages } from "./lazyPages";

export const auth = lazyPages(() => import("../pages/auth"));
export const status = lazyPages(() => import("../pages/status"));
export const caregiver = lazyPages(() => import("./caregiver"));
export const child = lazyPages(() => import("./child"));
export const provider = lazyPages(() => import("./provider"));
export const referral = lazyPages(() => import("./referral"));
